export default "__VITE_ASSET__DatXxbZT__"